module.exports = "/admin_success_screen-6be0c0079cf2033988538281fb869438.svg";